import {ValueObject} from '@s-ui/domain'

export class AlertInteractionUserAlertsValueObject extends ValueObject {
  #matchDate
  #missedTimeRange = 'missed'
  #recentTimeRange = 'recent'
  #timeRange
  #viewed

  constructor({matchDate, timeRange, viewed}) {
    super()
    this.#matchDate = matchDate
    this.#timeRange = timeRange
    this.#viewed = viewed
  }

  static create({matchDate, timeRange, viewed}) {
    return new AlertInteractionUserAlertsValueObject({matchDate, timeRange, viewed})
  }

  get matchDate() {
    return this.#matchDate
  }

  get timeRange() {
    return this.#timeRange
  }

  get viewed() {
    return this.#viewed
  }

  getIsMissed() {
    return this.#timeRange === this.#missedTimeRange
  }

  getIsRecent() {
    return this.#timeRange === this.#recentTimeRange
  }

  getValue() {
    return {
      matchDate: this.matchDate,
      timeRange: this.timeRange,
      viewed: this.viewed
    }
  }

  toJSON() {
    return {
      matchDate: this.matchDate,
      timeRange: this.timeRange,
      viewed: this.viewed
    }
  }
}
